import { Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import ArrowLeftIcon from "../svgIcon/ArrowLeftIcon";
import Tooltip from "@mui/material/Tooltip";
import { HelpIcon } from "../svgIcon/HelpIcon";

const AVCTitleWrapper = ({ children, firstTitle, secondTitle, educationalGuidanceLink }) => {
  const educationLink = process.env.REACT_APP_EDUCATION_PAGE;
  const theme = useTheme();

  function slugify() {
    return secondTitle.trim().replace(/\s+/g, "-");
  }
  const handleOpenPopup = () => {
    if (educationalGuidanceLink) {
      const parts = educationalGuidanceLink.split("/");
      const videoHash = parts.pop() || null;
      const slug = slugify();
      const FinalUrl = `${educationLink}/${videoHash}-${slug}`;
      window.open(FinalUrl, "_blank", "width=700,height=700,left=100,top=100,resizable=yes,scrollbars=yes");
    }
  };

  return (
    <Stack spacing={2} p={2} bgcolor="grey.gb" sx={{ borderRadius: 2 }}>
      <Stack direction="row" spacing={1}>
        <Typography variant="body1" color="primary.main">
          {firstTitle}
        </Typography>
        <ArrowLeftIcon fontSize="small" color={theme.palette.grey.gm} />
        <Typography variant="body1" color="text.primary">
          {secondTitle}
        </Typography>
        {educationalGuidanceLink && (
          <Tooltip title="محتوای آموزشی" placement="bottom">
            <Stack onClick={handleOpenPopup} sx={{ cursor: "pointer" }}>
              <HelpIcon fontSize="small" color={theme.palette.info.main} />
            </Stack>
          </Tooltip>
        )}
      </Stack>
      {children}
    </Stack>
  );
};

export default AVCTitleWrapper;
